export default {
  default: () => import("/home/forge/pininfarina.it/releases/20250625182455/layouts/default.vue").then(m => m.default || m)
}